/**
 * Created by vaibhav on 2/4/18
 */
import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import FAQ from "../components/FAQ";
import NavBar from '../components/NavBar';
import HeroCTA from '../components/HeroCTA';


export const FAQPageTemplate = ({
                                        title,
                                        subtitle,
                                        meta_title,
                                        meta_description,
                                        faqs,
                                        heromain,
                                        herosub,
                                        herourl
                                    }) => {
    return (
        <div>
            <Helmet>
                <title>{meta_title}</title>
                <meta name="description" content={meta_description}/>
            </Helmet>
            <NavBar/>
            <section className="hero is-primary is-bold">
                <div className="hero-body">
                    <div className="container">
                        <div className="columns">
                            <div className="column is-10 is-offset-1">
                                <div className="section">
                                    <h1 className="title">
                                        {title}
                                    </h1>
                                    <h2 className="subtitle">
                                        {subtitle}
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section">
                <div className="container">
                    {faqs.map((faq, id) =>
                        <FAQ key={id} question={faq.question} answer={faq.answer}/>
                    )}
                </div>
            </section>
            <section>
            <HeroCTA             heromain={heromain}
                            herosub={herosub}
                            herourl={herourl}/>
                            </section>
        </div>
    );
};

FAQPageTemplate.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    meta_title: PropTypes.string,
    meta_description: PropTypes.string,
    faqs: PropTypes.array,
    heromain: PropTypes.string,
    herosub: PropTypes.string,
    herourl: PropTypes.string,

};

const FAQPage = ({data}) => {
    const {frontmatter} = data.markdownRemark;
    return (
        <FAQPageTemplate
            title={frontmatter.title}
            subtitle={frontmatter.subtitle}
            meta_title={frontmatter.meta_title}
            meta_description={frontmatter.meta_description}
            faqs={frontmatter.faqs}
            heromain={frontmatter.heromain}
            herosub={frontmatter.herosub}
            herourl={frontmatter.herourl}
        />
    )
};
FAQPage.propTypes = {
    data: PropTypes.shape({
        markdownRemark: PropTypes.shape({
            frontmatter: PropTypes.object,
        }),
    }),
};

export default FAQPage;

export const contactPageQuery = graphql`
  query FAQPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        subtitle
        meta_title
        meta_description
        heading
        heromain
        herosub
        herourl
        faqs {
          question
          answer
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/faq-page.js